<template>
    <div class="w-full max-w-md">
        <div class="flex h-full w-full flex-col divide-y">
            <NotificationItem
                v-for="(notification, index) in notificationsStore.all"
                :key="index"
                :notification="notification"
                @notification-clicked="handleClick"
                @mark-read="markRead"
            />
        </div>
    </div>
</template>

<script setup>
import { useNotificationsStore } from '@store/notifications';

const notificationsStore = useNotificationsStore();
const router = useRouter();
const emit = defineEmits(['close']);

const handleClick = async (notification) => {
    if (!notification.read_at) {
        try {
            await notificationsStore.read(notification.id);
        } catch (error) {
            console.error('Error marking notification as read', notification.id, error);
        }
    }
    emit('close');

    if (notification.data.url) {
        // Parse the URL to extract path and query parameters
        try {
            let url;
            // Handle both absolute URLs and relative paths
            if (notification.data.url.startsWith('http://') || notification.data.url.startsWith('https://')) {
                url = new URL(notification.data.url);
            } else {
                // Relative path - use current origin as base
                url = new URL(notification.data.url, window.location.origin);
            }

            const queryParams = {};
            url.searchParams.forEach((value, key) => {
                queryParams[key] = value;
            });

            router.push({
                path: url.pathname,
                query: queryParams,
            });
        } catch {
            // Fallback: try to parse manually if URL constructor fails
            const urlParts = notification.data.url.split('?');
            const path = urlParts[0];
            const queryParams = {};

            if (urlParts[1]) {
                const params = new URLSearchParams(urlParts[1]);
                params.forEach((value, key) => {
                    queryParams[key] = value;
                });
            }

            router.push({
                path: path,
                query: queryParams,
            });
        }
    }
};

async function markRead(notification) {
    if (!notification.read_at) {
        await notificationsStore.read(notification.id);
    }
}
</script>
